__turbopack_context__.v({
  "answer": "download-module__qzFqLW__answer",
  "badge": "download-module__qzFqLW__badge",
  "container": "download-module__qzFqLW__container",
  "eyebrow": "download-module__qzFqLW__eyebrow",
  "faq": "download-module__qzFqLW__faq",
  "hero": "download-module__qzFqLW__hero",
  "heroActions": "download-module__qzFqLW__heroActions",
  "page": "download-module__qzFqLW__page",
  "platform": "download-module__qzFqLW__platform",
  "platformHeading": "download-module__qzFqLW__platformHeading",
  "platformIcon": "download-module__qzFqLW__platformIcon",
  "platformTitle": "download-module__qzFqLW__platformTitle",
  "platforms": "download-module__qzFqLW__platforms",
  "primary": "download-module__qzFqLW__primary",
  "section": "download-module__qzFqLW__section",
  "sectionHeading": "download-module__qzFqLW__sectionHeading",
  "skills": "download-module__qzFqLW__skills",
  "stepNumber": "download-module__qzFqLW__stepNumber",
  "steps": "download-module__qzFqLW__steps",
  "support": "download-module__qzFqLW__support",
  "textLink": "download-module__qzFqLW__textLink",
  "unavailable": "download-module__qzFqLW__unavailable",
});
